<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { RouterView } from 'vue-router'
import { hall } from '@/hall'
import { Country } from '@/defines/EnumDefine'

const updateTheme = () => {
  const country = hall.configModule.country
  const root = document.documentElement

  // Remove existing country classes
  root.classList.remove('theme-pak', 'theme-usa', 'theme-india', 'theme-bangladesh')

  // Add specific theme class
  if (country === Country.Pakistan) {
    root.classList.add('theme-pak')
  } else if (country === Country.USA) {
    root.classList.add('theme-usa')
  } else if (country === Country.India) {
    root.classList.add('theme-india')
  } else if (country === Country.Bangladesh) {
    root.classList.add('theme-bangladesh')
  } else {
    // Default to Pakistan/Green if unknown
    root.classList.add('theme-pak')
  }
}

onMounted(() => {
  updateTheme()
  hall.eventDispatcher.on(hall.EventDefine.ConfigChange, updateTheme)
})

onUnmounted(() => {
  hall.eventDispatcher.off(hall.EventDefine.ConfigChange, updateTheme)
})
</script>

<template>
  <RouterView />
</template>

<style>
/* Global resets done in base.css / main.css */
</style>
